import Slider from "react-slick";
import React from 'react';
import SpecialsItem from './specials-item';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
//
// import 'react-slidy/lib/styles.css'
// import ReactSlidy from 'react-slidy'


export default class SimpleSlider extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  render() {

    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      centerMode: false,
      adaptiveHeight: true
    };
    const list = this.props.data.map((special)=> {
        return(<SpecialsItem key={special.title} data={special} />)
        });
    return (

      <div className="slider-container">
        <Slider {...settings}>
        {list}
        </Slider>
      </div>
    );
  }
}
